import axios from "axios";

const NODE_ENV = process.env.NODE_ENV;
// const SSO_URL =
//   NODE_ENV === "development"
//     ? "http://hoadev.ddns.net:30004/"
//     : process.env.VUE_APP_SSO_URL;

const SSO_URL = process.env.VUE_APP_SSO_URL;

export default (ictToken) => {
  return axios({
    method: "post",
    url: SSO_URL + "refresh",
    headers: {
      Authorization: "Bearer " + ictToken,
    },
  });
};
